package com.milta.feature.delivery.domain.usecase

import com.milta.feature.delivery.domain.entity.AddressValidation
import com.milta.feature.delivery.domain.repository.DeliveryRepository

class ValidateAddressUseCase(private val repository: DeliveryRepository) {
    suspend operator fun invoke(address: String): AddressValidation = repository.validateAddress(address)
}
